import { motion } from "framer-motion";

// Calm editorial easing. No spring, no bounce.
export const EASE = [0.16, 1, 0.3, 1];

export const revealVariants = {
  hidden: { y: 40, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: EASE },
  },
};

// Scroll-triggered reveal wrapper.
export const Reveal = ({ children, className = "", delay = 0, as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
      variants={{
        hidden: { y: 40, opacity: 0 },
        visible: {
          y: 0,
          opacity: 1,
          transition: { duration: 0.8, ease: EASE, delay },
        },
      }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Small uppercase label used across chapters.
export const Kicker = ({ children, className = "" }) => (
  <span
    className={`text-xs md:text-sm tracking-[0.2em] uppercase font-medium text-brass ${className}`}
  >
    {children}
  </span>
);
